/**
 * Third-Party Loader - deferred loading of third-party scripts the theme itself owns.
 *
 * 0.6.110: PostHog, Braze and Impact were removed from this file. They belong to
 * plugins (bb-posthog-utm, bb-braze) where they get admin toggles, API-key
 * settings, EU hosts and Cookiebot consent categories. The PostHog/Braze branches
 * here were dead anyway (they read <meta name="posthog-api-key|braze-api-key">
 * tags nothing printed) and the Impact tag loaded ungated on every thank-you page.
 *
 * Loading tiers:
 * - TIER 2 (viewport): Bazaarvoice reviews (only where a [data-bv-show] element exists)
 * - TIER 3 (click): Zendesk (handled by facade in footer)
 */

const loaded = new Set();

function loadScript( id, src, onLoad ) {
	if ( loaded.has( id ) ) {
		return;
	}
	loaded.add( id );

	const script = document.createElement( 'script' );
	script.src = src;
	script.async = true;
	if ( onLoad ) {
		script.onload = onLoad;
	}
	document.head.appendChild( script );
}

// TIER 2: Bazaarvoice - load when reviews section is visible.
function loadBazaarvoice() {
	const reviewsEl = document.querySelector( '[data-bv-show]' );
	if ( ! reviewsEl ) {
		return;
	}

	const observer = new IntersectionObserver( ( entries ) => {
		if ( entries[ 0 ].isIntersecting ) {
			loadScript( 'bv', 'https://apps.bazaarvoice.com/deployments/mybirdbuddy/main_site/production/en_US/bv.js' );
			observer.disconnect();
		}
	}, { rootMargin: '200px' } );

	observer.observe( reviewsEl );
}

// --- Initialize ---

function init() {
	loadBazaarvoice();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
